import { type FC } from 'react';
import { Button, Text } from '@chakra-ui/react';
import { translate } from '../../../../constants/translation';
import { ReactComponent as RequestOperationIcon } from '../../../../assets/svg/RequestOperationIcon.svg';
import { externalLinks } from '../../../../constants/constants';

export const RequestOperationButton: FC = () => {
  return (
    <Button
      variant="secondary"
      leftIcon={<RequestOperationIcon />}
      onClick={e => {
        window.open(externalLinks.requestNewOperationForm, '_blank');
        e.stopPropagation();
      }}
    >
      <Text>{translate('REQUEST_NEW_OPERATION')}</Text>
    </Button>
  );
};

export default RequestOperationButton;
